import { shape, number, string } from 'prop-types';

const salesTaxBasicInformationPropTypes = {
  country: shape({
    name: string.isRequired,
  }).isRequired,
  taxRate: number.isRequired,
};

export default salesTaxBasicInformationPropTypes;
